import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TagsAta } from '../tags-ata.enum';

declare var $: any;

@Component({
  selector: 'lib-modelo-ata-dlg',
  templateUrl: './modelo-ata-dlg.component.html'
})
export class ModeloAtaDlgComponent implements OnInit {

  @Output() callback: EventEmitter<string> = new EventEmitter();
  @Input() public modelo: string;
  public tags: { tag: string, descricao: string }[];

  constructor(
  ) { }

  ngOnInit(): void {
    this.tags = [
      { tag: 'PROCESSO', descricao: TagsAta.PROCESSO },
      { tag: 'NUMERO', descricao: TagsAta.NUMERO },
      { tag: 'MODALIDADE', descricao: TagsAta.MODALIDADE },
      { tag: 'OBJETO', descricao: TagsAta.OBJETO },
      { tag: 'DATA_JULGAMENTO', descricao: TagsAta.DATA_JULGAMENTO },
      { tag: 'HORA_JULGAMENTO', descricao: TagsAta.HORA_JULGAMENTO },
      { tag: 'SALA', descricao: TagsAta.SALA },
      { tag: 'MEMORIAL', descricao: TagsAta.MEMORIAL },
      { tag: 'HISTORICO', descricao: TagsAta.HISTORICO },
      { tag: 'ASSINATURAS', descricao: TagsAta.ASSINATURAS },
      { tag: 'PROPONENTES', descricao: TagsAta.PROPONENTES },
      { tag: 'QUADRO_LANCES', descricao: TagsAta.QUADRO_LANCES },
      { tag: 'CLASSIFICACAO', descricao: TagsAta.CLASSIFICACAO },
      { tag: 'VENCEDORES', descricao: TagsAta.VENCEDORES },
    ]
  }

  public fechar() {
    this.callback.emit(this.modelo);
    $('#dialogModeloAta').modal('hide');
  }
}
